import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../services/auth.service';
import {Router} from '@angular/router';
import {first} from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  hide = true;
  username: string = '';
  password: string = '';
  error: string = '';


  constructor(private auth: AuthService, private router: Router) {
  }

  public submit() {
    this.auth.login(this.username, this.password)
      .pipe(first())
      .subscribe(
        result => {
          this.error = '';
          this.router.navigate(['admin'])
        },
        err => this.error = 'Impossible d\'authentifier'
      );
  }

  ngOnInit() {
    if (this.auth.loggedIn) {
      this.router.navigate(['admin'])
    }
  }

}
